var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamAdministrative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D3FC5009-C176-4615-9ED8-60E4A4FB3BFF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Teams",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-518.000000, -1534.000000)",
    id: "team_administrative"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(518.000000, 1534.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 1.4,
    x: 10.9941176,
    y: 38.9352941,
    width: 28.0117647,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    fill: "#FFFFFF",
    x: 23.1,
    y: 10.2941176,
    width: 4.41176471,
    height: 2.05882353,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1176471,7.18235294 C42.3109467,7.18235294 42.4859467,7.26070311 42.6126218,7.38737819 C42.7392969,7.51405328 42.8176471,7.68905328 42.8176471,7.88235294 L42.8176471,31.0529412 L7.18235294,31.0529412 L7.18235294,7.88235294 C7.18235294,7.68905328 7.26070311,7.51405328 7.38737819,7.38737819 C7.51405328,7.26070311 7.68905328,7.18235294 7.88235294,7.18235294 Z",
    id: "Rectangle",
    stroke: "#FFFFFF",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8899646,32.1823529 L47.6211003,43.3144368 C47.6967076,43.4923365 47.6930491,43.6840403 47.6260139,43.8501711 C47.5589787,44.0163019 47.4285667,44.1568596 47.2506671,44.2324669 L3.02313138,44.2882353 C2.82983172,44.2882353 2.65483172,44.2098851 2.52815663,44.08321 C2.40148155,43.956535 2.32313138,43.781535 2.32313138,43.5882353 L7.1100354,32.1823529 L42.8899646,32.1823529 Z",
    id: "Rectangle-Copy-8",
    stroke: "#FFFFFF",
    strokeWidth: 2.6
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAdministrative);
export default __webpack_public_path__ + "static/media/team_administrative.ed6617133c847ee96da96a761ca35bc0.svg";
export { ForwardRef as ReactComponent };